import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { AxiosError, HttpStatusCode } from 'axios';

export enum TenantAppState {
	Unconfigured = "Unconfigured",
	InProgress = "InProgress",
	Maintenance = "Maintenance",
	Failed = "Failed",
	AccountDataRemoving = "AccountDataRemoving",
	Configured = "Configured",
	KIRestricted = "KIRestricted"
}

export type TenantAppStateResponse = {
	status: 'Success' | 'Failed' | 'Unauthorized',
	data?: {
		readonly code: TenantAppState;
		readonly data?: {
			[key: string]: any
		}
	}
};

export class TenantAppStateQuery extends Query<TenantAppStateResponse> { }

export class TenantAppStateQueryHandlerBase implements QueryHandler<TenantAppStateQuery, TenantAppStateResponse> {
	private static Url = TaggedUrl.join('myCompany/tenantAppState', [Tags.Api, Tags.OmitMessage]);

	public constructor(private readonly $http: HttpService) { }

	public async handleAsync(q: TenantAppStateQuery): Promise<TenantAppStateResponse> {
		try {
			const { data } = await this.$http.get<TenantAppStateResponse['data']>(TenantAppStateQueryHandlerBase.Url);
			return { status: 'Success', data };

		} catch (err) {
			const error = err as AxiosError;
			if (error.status === HttpStatusCode.Unauthorized) return { status: 'Unauthorized' };
			return { status: 'Failed' };
		}
	}
}
